import { literal, object } from 'superstruct';
import { ListResourceDto } from '@arc/shared/util-data';
import { arcApiSchema } from '@arc/shared/util-route-schema';
import { parsableInteger } from '@arc/shared/util-superstruct';
import { EditCleanupTaskDto } from './edit-cleanup-task.dto';
import { ListCleanupTaskQueryDto } from './list-cleanup-task-query.dto';
import { ViewCleanupTaskDto } from './view-cleanup-task.dto';
const p = arcApiSchema.prefix('arc-cleanup');
export const ListCleanupTasks = p.get('', {
  req: object({
    query: ListCleanupTaskQueryDto
  }),
  res: ListResourceDto(ViewCleanupTaskDto)
});
export const GetCleanupTask = p.get(':arcCleanupId', {
  req: object({
    params: object({
      arcCleanupId: parsableInteger()
    })
  }),
  res: ViewCleanupTaskDto
});
export const EditCleanupTask = p.patch(':arcCleanupId', {
  req: object({
    params: object({
      arcCleanupId: parsableInteger()
    }),
    body: EditCleanupTaskDto
  }),
  res: ViewCleanupTaskDto
});
export const ArchiveCleanupTask = p.delete(':arcCleanupId', {
  req: object({
    params: object({
      arcCleanupId: parsableInteger()
    })
  }),
  res: literal(undefined)
});